import {css} from 'lit';
export const styles = css`:host {
  --notes-padding: 16px 0 16px 0;
  --notes-color: var(--dark-text-secondary);
  --notes-font-size: var(--font-size-sm, 12px);
  --notes-font-style: italic;
  --notes-gap: 4px;
  --checkbox-button-border-radius: 4px;
  --radio-button-border-radius: 50%;

  display: block;
}

  :host ::slotted(*) {
    --button-border-radius: var(--radio-button-border-radius);
  }

:host([isMultipleChoice]) ::slotted(*) {
  --button-border-radius: var(--checkbox-button-border-radius);
}

.note {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  flex-wrap: wrap;
  padding: var(--notes-padding);
  color: var(--notes-color);
  font-size: var(--notes-font-size);
  font-style: var(--notes-font-style);
}

.labels {
  margin: 8px 16px 8px 0;
}

.labels > *:not(:first-child),
  .labels ::slotted(*) {
    margin-top: var(--notes-gap);
  }

.buttons {
  flex: 1;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  flex-wrap: wrap;
  white-space: nowrap;
}

.buttons ::slotted(*) {
    margin-top: 8px;
    margin-bottom: 8px;
  }
`;
export default styles;
